import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import agent from '../agent'

import Back from '../components/Back'
import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';

const Header = ({artist, fromRegistration}) => {
	return (
		<section id="brand-logo" className="section-brand-logo dashboard-header section">
		  <div className="row">
		  <div className="small-12 small-centered column text-center">
		  	<img className="am-logo" src={AMLogo} alt=""/>
		  	
		  	<div className="with-name post-relative">
		  			<Back />
			  		<h2>Welcome { !fromRegistration && "Back" } {artist.first_name}</h2>
				    <p className="top-title">Please select the Project you are auditioning for below</p>
		    </div>

		  </div>
		  </div>
		</section>
	)
}

const ProjectList = ({projects}) => (
	<Aux>
	{
		projects.map(project => 
			<div className={`column column-block`} key={project.id}>
				<div className="project-item-container">
				<Link to={`/projects/checkin/${project.id}`} key={project.id}>
			    <div className="image-container">
			    	<img src={project.cover_url || AMLogo } alt=""/>
			    </div>
			    <div className="card-divider align-justify">
				    <div className="status">
		      	<label className="project-name">{project.name}</label>
		      	</div>
	      	</div>
			  </Link>
			  </div>
			</div>
		)
	}
	</Aux>
)

const InformStaff = prop => {
	return (
		<div className="row inform-staff-container">
			<div className="small-12 medium-8 medium-centered column">
				<p>
					There are currently no projects for you to apply to or that you are scheduled for. 
					However if you are currently at an audition now, please notify the staff that you have created a profile. 
					So they can assign you to the project allowing you to check-in.
				</p>	
			</div>
		</div>
	)
}

class ArtistProjectContainer extends Component {
	componentDidMount() {
		const { location } = this.props

		console.log('>>componentDidMount',location.state.artistInfo)
		this.props.getProjects(location.state.artistInfo.id);
  }
  componentWillUnmount() {
  	const { location } = this.props
  	console.log('>>componentWillUnmount',location.state.artistInfo)
    // window.clearInterval(this.interval)
  }

render() {
		console.log('>>>P', this.props)
		console.log('>>>S', this.state)
		const { projects, fromRegistration } = this.props

		if (projects) {
			return (
				<div>
					<Header artist={this.props.location.state.artistInfo} fromRegistration={fromRegistration} />
					
					<section id="project-selection" className="section-getting-started gray-bg section">
						<div className="row">
						<div className="small-12 small-centered columns text-center">
						<div className="row small-up-2 large-up-3">
						
						{ projects.length
							? <ProjectList projects={projects} />
							: <InformStaff />
						}
						
						</div>
						</div>
						</div>
					</section>

				</div>
			)
		}

		return (
			<div>
				<Header artist={this.props.location.state.artistInfo}  fromRegistration={fromRegistration}  />
				<section className="gray-bg section">
					<p className="text-center loading-text">Loading Projects...</p>
				</section>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	...state.artist
  // tick: state.auth.tick,
})
const mapDispatchToProps = (dispatch) => ({
	getProjects: id =>
		dispatch({ type: 'ARTIST_PROJECTS', payload: agent.Artist.projects(id) })
  // tickIncrement: () => dispatch({ type: TICK }),
})
export default connect(mapStateToProps, mapDispatchToProps)(ArtistProjectContainer)


// WEBPACK FOOTER //
// ./src/containers/ArtistProjectsContainer.js